import * as React from 'react';

import ContentWrapper from 'src/SharedComponents/ContentWrapper';
import EndText from 'src/SharedComponents/EndText';

const SavedPage = () => {

    return <ContentWrapper>
        <EndText>Your answers have been saved.</EndText>
    </ContentWrapper>;
};

export default SavedPage;


// WEBPACK FOOTER //
// ./src/Forms/SavedPage.tsx